import { usePatentPrimaryCategoryQuery } from "@api/patent/patentPrimaryCategory/usePatentPrimaryCategory";
import ResetIcon from "@images/pressList/icon-reload.svg";
import SearchFilterTag from "@PressListContainer/shared/components/SearchFilterTag/SearchFilterTag";
import { usePatentListFilterState } from "@stores/patentList";

import {
  EDITOR_INFO_CODE,
  STATUS_FILTER,
  StatusCode,
} from "./constants/filterCode.constants";
import * as S from "./PatentSearchResult.style";

interface SearchType {
  [key: string]: string | undefined;
}

const PatentSearchResult = () => {
  const [patentListFilter, setPatentListFilter] = usePatentListFilterState();
  const { data: patentPrimaryCategoryData } = usePatentPrimaryCategoryQuery();

  const { search, patentListDataTotal, primaryCategory, status } =
    patentListFilter;

  const isSearch =
    (search && !!Object.keys(search).length) ||
    !!primaryCategory.length ||
    !!status.length;

  const handleDeletePrimaryCategory = (currentCode: string) => {
    setPatentListFilter({
      ...patentListFilter,
      primaryCategory: primaryCategory.filter(
        (filterCode) => filterCode !== currentCode,
      ),
      page: 1,
    });
  };

  const handleDeleteStatus = (currentCode: string) => {
    const deleteStatusFilter = status.filter(
      (filterCode) => filterCode !== currentCode,
    );

    setPatentListFilter({
      ...patentListFilter,
      status: deleteStatusFilter,
      page: 1,
    });
  };

  const handleDeleteSearch = (currentKey: string) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [currentKey]: currentSearch, ...otherSearch } =
      search as SearchType;

    setPatentListFilter({
      ...patentListFilter,
      search: {
        ...otherSearch,
      },
      page: 1,
    });
  };

  const handleResetFilter = () => {
    setPatentListFilter({
      ...patentListFilter,
      search: {},
      primaryCategory: [],
      status: [],
    });
  };

  const handleCheckIdInfoSearch = (key: string, value: string) => {
    if (key !== "idInfo") return value;

    const idValue = value.replace(/#/g, "");

    return `#${idValue}`;
  };

  return (
    <>
      {isSearch && (
        <S.SearchResult>
          <S.SearchResultText>Search Results for</S.SearchResultText>
          {search &&
            Object.entries(search).map(
              ([key, value]) =>
                value && (
                  <SearchFilterTag
                    key={key}
                    type="result"
                    text={handleCheckIdInfoSearch(key, value)}
                    isAllInfo={!!(key === "allInfo" || key === "allEditorInfo")}
                    isUserInput
                    code={EDITOR_INFO_CODE[key]}
                    onClickDeleteButton={() => handleDeleteSearch(key)}
                  />
                ),
            )}
          {primaryCategory.map((code) => (
            <SearchFilterTag
              key={code}
              type="result"
              text={
                code === "" ? "None" : patentPrimaryCategoryData?.[code] || ""
              }
              isAllInfo={false}
              isRegulatoryClassification
              onClickDeleteButton={() => handleDeletePrimaryCategory(code)}
            />
          ))}
          {status &&
            status.map((statusCode) => (
              <SearchFilterTag
                key={statusCode}
                type="result"
                text={STATUS_FILTER[statusCode as StatusCode]}
                isAllInfo={false}
                code={statusCode}
                onClickDeleteButton={() => handleDeleteStatus(statusCode)}
              />
            ))}
          <S.SearchTotalCount>({patentListDataTotal})</S.SearchTotalCount>
          <S.ResetButton onClick={handleResetFilter}>
            <img src={ResetIcon} width={10} alt="filter reset icon" />
            <S.ResetButtonText>Filter Reset</S.ResetButtonText>
          </S.ResetButton>
        </S.SearchResult>
      )}
    </>
  );
};

export default PatentSearchResult;
